import { render, staticRenderFns } from "./ResetPasswordDialog.vue?vue&type=template&id=3c37162a&"
import script from "./ResetPasswordDialog.vue?vue&type=script&lang=ts&"
export * from "./ResetPasswordDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports